import { prop } from 'ramda';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';
import { useSocketSelector } from '@core/js/store/hooks';
import { useShowSmsVerification } from './useShowSmsVerification';
import { toggleReconnectVisible } from '@core/js/components/system/App/store/actions';

export const useAppNotifier = () => {
    const dispatch = useDispatch();
    const connected = useSocketSelector(prop('connected'));
    const [online, setOnline] = useState(true);
    const showSmsVerification = useShowSmsVerification();

    const showSmsVerificationCallback = useCallback((data) => {
        showSmsVerification(data);
    }, [showSmsVerification]);

    const handleOnline = useCallback(() => setOnline(true), []);
    const handleOffline = useCallback(() => setOnline(false), []);

    useEffect(() => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        dispatcher.listen('show:phone-verification', showSmsVerificationCallback);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            dispatcher.removeListener('show:phone-verification', showSmsVerificationCallback);
        };
    }, [showSmsVerification, handleOnline, handleOffline, showSmsVerificationCallback]);

    useEffect(() => {
        dispatch(toggleReconnectVisible(!connected || !online));

        if (connected) {
            dispatcher.dispatch('openapi:connected');
        }
    }, [
        dispatch,
        online,
        connected
    ]);
};

